import { path } from '#app/utils/pz/routes.generated'

const BRANDS_WITH_GENERIC_MARKETING_SIGNUP = new Set(['arkeias'])

const LEGACY_MARKETING_ACQUISITION_TARGETS = [
	'/programs',
	'/roadmaps',
	'/collections',
	'/pricing',
] as const

export function brandUsesGenericMarketingSignup(brandKey: string): boolean {
	return BRANDS_WITH_GENERIC_MARKETING_SIGNUP.has(brandKey)
}

export function getMarketingSignupHrefOverride(params: {
	brandKey: string
	leadMagnetSignupPath: string
}): string | null {
	return brandUsesGenericMarketingSignup(params.brandKey)
		? null
		: params.leadMagnetSignupPath
}

export function getMarketingHomeAnonymousCtaTargetPath(params: {
	brandKey: string
	leadMagnetSignupPath: string
}): string {
	return brandUsesGenericMarketingSignup(params.brandKey)
		? path('auth.signup')
		: params.leadMagnetSignupPath
}

export function getMarketingHomeCtaTargets(params: {
	brandKey: string
	isAuthenticated: boolean
}): Set<string> {
	const targets = new Set<string>(LEGACY_MARKETING_ACQUISITION_TARGETS)

	if (!brandUsesGenericMarketingSignup(params.brandKey)) {
		targets.add(path('auth.signup'))
	}

	return targets
}

export function shouldPrioritizeMarketingHomeLeadMagnet(
	brandKey: string,
): boolean {
	return !brandUsesGenericMarketingSignup(brandKey)
}
